import { Component } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { NavController } from 'ionic-angular';
import { GroupPermissionsPage } from '../group-permissions/group-permissions';
import { InvitePage } from '../invite/invite';

@Component({
  selector: 'page-group-view',
  templateUrl: 'group-view.html'
})
export class GroupViewPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController, private alertCtrl: AlertController) {
  }

  goToGroupPermissions(params) {
    if (!params) params = {};
    this.navCtrl.push(GroupPermissionsPage);
  }

  goToInvite(params) {
    if (!params) params = {};
    this.navCtrl.push(InvitePage);
  }

  goToGroupView(params) {
    if (!params) params = {};
    this.navCtrl.push(GroupViewPage);
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: 'Add Contact to Group',
      subTitle: 'Could just show a list of contacts not in group to add with single or multiple select. However, ' +
      'should consider ownership of the group.  Can anyone in the group add to the group or are their group rights?' +
      'Also, can we invite a new user to Upd8td here and they are added to the group when they join?',
      buttons: ['Dismiss']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/group-view/group-view.ts